@if (showInviteModal()) {
<div class="fixed inset-0 z-50 flex items-center justify-center bg-black/30">
  <app-modal-invite-guests class="w-[500px]" [title]="'modal.invite_guests.title' | translate"
    [subtitle]="'modal.invite_guests.subtitle' | translate: { max: maxInvite() }"
    [countLabel]="'modal.invite_guests.count_label' | translate" [maxCount]="maxInvite()"
    [initialCount]="inviteCount() === 0 ? 1 : inviteCount()"
    [requiredErrorMessage]="'modal.invite_guests.required_error' | translate: { max: maxInvite() }"
    [commentLabel]="'modal.invite_guests.comment_label' | translate"
    [commentPlaceholder]="'modal.invite_guests.comment_placeholder' | translate"
    [initialComment]="inviteComment()"
    [commentRequiredErrorMessage]="'modal.invite_guests.comment_required_error' | translate"
    [cancelLabel]="'common.cancel' | translate" [confirmLabel]="'common.confirm' | translate"
    (cancelClick)="onInviteCancel()" (confirmClick)="onInviteConfirm($event)" />
</div>
}

<!-- Bar Haute : info convive + actions -->
<div class="border-t border-b border-gris-3 flex items-center justify-between p-5 h-[88px] shrink-0">
  <!-- Bouton Retour -->
  <button type="button" (click)="goBack()"
    class="shrink-0 border border-gris-3 rounded-[5px] h-[58px] px-5 flex items-center gap-[10px] fg-noir-2 text-[16px] font-medium cursor-pointer hover:bg-gris-4 transition-colors">
    <app-svg class="fg-gris-1 shrink-0" height="20" svgPath="assets/svg/arrow-back.svg" width="20" />
    {{ 'common.back' | translate }}
  </button>

  <!-- Infos convive -->
  <div class="flex items-center justify-center gap-4 flex-1 min-w-0 overflow-hidden">
    @if (currentMealPlan()) {
    <div class="flex flex-col items-start min-w-0 max-w-[190px]">
      <span class="fg-gris-1 text-[16px] truncate w-full">{{
        'order_header.menu_selected_label' | translate
        }}</span>
      <div class="flex items-center gap-[10px] min-w-0 w-full">
        <span class="fg-noir-2 text-[18px] font-semibold truncate" [title]="currentMealPlan()!.admission_name">{{
          currentMealPlan()!.admission_name
          }}</span>
        <div class="size-[5px] rounded-full bg-gris-2 shrink-0"></div>
        <span class="fg-vert-1 text-[18px] font-semibold shrink-0">{{
          currentMealPlan()!.final_price | formatPrice
          }}</span>
      </div>
    </div>

    <div class="w-px h-[47px] bg-gris-3 shrink-0"></div>
    }

    <div class="flex flex-col items-start min-w-0 max-w-[130px]">
      <span class="fg-gris-1 text-[16px] truncate w-full">{{ 'choose_order_type.name_label' | translate }}</span>
      <span class="fg-noir-2 text-[18px] font-semibold truncate w-full"
        [title]="customer()?.firstname && customer()?.lastname ? customer()!.firstname + ' ' + customer()!.lastname : null">
        @if (customer()?.firstname && customer()?.lastname) {
        {{ customer()!.firstname }} {{ customer()!.lastname }}
        } @else {
        {{ 'common.none' | translate }}
        }
      </span>
    </div>

    <div class="w-px h-[47px] bg-gris-3 shrink-0"></div>

    <div class="flex flex-col items-start min-w-0 max-w-[140px]">
      <span class="fg-gris-1 text-[16px] truncate w-full">{{ 'choose_order_type.status_label' | translate }}</span>
      <span class="fg-noir-2 text-[18px] font-semibold truncate w-full"
        [title]="userEnterpriseData()?.professional_social_category?.name || null">{{
        userEnterpriseData()?.professional_social_category?.name || 'common.none' | translate
        }}</span>
    </div>

    <div class="w-px h-[47px] bg-gris-3 shrink-0"></div>

    <div class="flex flex-col items-start min-w-0 max-w-[190px]">
      <span class="fg-gris-1 text-[16px] truncate w-full">{{ 'choose_order_type.payment_label' | translate }}</span>
      <div class="flex items-center gap-[10px] min-w-0 w-full">
        <span class="fg-noir-2 text-[18px] font-semibold truncate">
          @if (paymentTypeKey()) {
          {{ paymentTypeKey() | translate }}
          } @else {
          {{ 'common.none' | translate }}
          }
        </span>
        @if (paymentTypeKey() == 'payment_type.wallet') {
        <div class="size-[5px] rounded-full bg-gris-2 shrink-0"></div>
        <span [class]="getBalanceColor()" class="text-[18px] font-semibold shrink-0">
          @if (customer()?.wallet?.currency) {
          {{ customer()!.wallet!.currency / 100 | formatPrice }}
          } @else {
          {{ 0 | formatPrice }}
          }
        </span>
        }
      </div>
    </div>
  </div>

  <div class="flex items-center gap-[10px] shrink-0">
    <!-- Navigation convive -->
    @if (showGuestNav()) {
    <div class="flex items-center h-[58px] border border-gris-3 rounded-[5px] shrink-0 overflow-hidden"
      [attr.aria-label]="'order_header.guest_order_label' | translate">
      <button type="button" (click)="goToPreviousGuest()" [disabled]="!canGoPrevious()"
        class="h-full w-[40px] flex items-center justify-center cursor-pointer hover:bg-gris-4 disabled:opacity-30 disabled:cursor-not-allowed transition-colors">
        <app-svg class="fg-gris-1" height="16" svgPath="assets/svg/arrow-back.svg" width="16" />
      </button>
      <span class="px-1 text-[16px] font-semibold fg-noir-2 whitespace-nowrap">
        {{ currentPersonPosition() }}/{{ totalParticipants() }}
      </span>
      <button type="button" (click)="goToNextGuest()" [disabled]="!canGoNext()"
        class="h-full w-[40px] flex items-center justify-center cursor-pointer hover:bg-gris-4 disabled:opacity-30 disabled:cursor-not-allowed transition-colors">
        <app-svg class="fg-gris-1 rotate-180" height="16" svgPath="assets/svg/arrow-back.svg" width="16" />
      </button>
    </div>
    }

    <!-- Bouton Inviter -->
    @if (canInvite()) {
    <div class="flex items-center h-[58px] border border-gris-3 rounded-[5px] shrink-0 overflow-hidden">
      <button type="button" (click)="openInviteModal()"
        class="h-full px-5 flex items-center gap-[10px] fg-noir-2 text-[16px] font-medium cursor-pointer hover:bg-gris-4 transition-colors">
        <app-svg class="fg-gris-1 shrink-0" height="20" svgPath="assets/svg/user.svg" width="20" />
        {{ 'order_header.invite_button' | translate }}
        @if (inviteCount() > 0) {
        <span
          class="bg-vert-1 fg-blanc text-[12px] font-semibold rounded-full size-[20px] shrink-0 flex items-center justify-center">
          {{ inviteCount() }}
        </span>
        }
      </button>
      @if (inviteCount() > 0) {
      <button type="button" (click)="cancelInvites($event)"
        [attr.aria-label]="'order_header.cancel_invite_button' | translate"
        class="h-full w-[58px] shrink-0 border-l border-gris-3 flex items-center justify-center cursor-pointer hover:bg-gris-4 transition-colors">
        <app-svg class="fg-gris-1" height="20" svgPath="assets/svg/close-circle.svg" width="20" />
      </button>
      }
    </div>
    }

    <!-- Bouton Annuler -->
    <button type="button" (click)="cancel()"
      class="border border-gris-3 rounded-[5px] h-[58px] px-5 flex items-center gap-[10px] fg-noir-2 text-[16px] font-medium cursor-pointer hover:bg-gris-4 transition-colors">
      {{ 'common.cancel' | translate }}
      <app-svg svgPath="assets/svg/close-circle.svg" width="20" height="20" />
    </button>
  </div>
</div>

<div class="flex-1 min-h-0 overflow-hidden">
  <router-outlet></router-outlet>
</div>